<template>
    <div :id="identificator" class="hidden" />
</template>

<script>
import load from './mixins/load';

const nexMartLoaderUrl = 'https://www.nexmart.com/api/dataview/assets/dataview.loader.min.js';
const nexMartResizerUrl = 'https://www.nexmart.com/api/dataview/assets/iframeResizer.min.js';

export default {
    mixins: [load],
    props: {
        productId: {
            type: String,
            required: true,
        },
        partnerKey: {
            type: String,
            required: true,
        },
        supplier: {
            type: String,
            required: true,
        },
        lang: {
            type: String,
            required: false,
            default: 'deu',
        },
    },
    data: () => ({
        identificator: 'nextmart-dataview-conaine',
    }),
    mounted() {
        if (!document.getElementById(this.hash(nexMartLoaderUrl))) {
            // Script is not loaded yet, we initialize new load
            this.load(100, 10000, [nexMartLoaderUrl, nexMartResizerUrl], () => {
                this.nexmartInit();
            });
        } else {
            // Script is already loaded just create new nexmart dataview
            this.nexmartInit();
        }
    },
    methods: {
        nexmartInit() {
            let element = document.getElementById(this.identificator);
            let options = {
                productId: this.productId,
                supplier: this.supplier,
                partnerkey: this.partnerKey,
                language: this.lang,
                debug: false,
                errorCallback: function(error) {
                    this.className += ' error';
                    console.log(error);
                },
                loadCallback: function(response) {
                    if (response.status === 'success') {
                        this.style.display = 'block';
                    }
                },
            };

            new DataviewLoader(element, options);
        },
    },
};
</script>

<style scoped>
.hidden {
    display: none;
}
</style>
